import '../../_headstarter/js/script';

import ResponsiveWrapper from 'ResponsiveWrapper';
import DoubleTouch from 'DoubleTouch';
import OnePageNavigation from 'OnePageNavigation';

(function($, window, document, undefined ) {
	var $window = jQuery(window);

	// Make content elements responsive
	ResponsiveWrapper.wrapDefaultSelectors();

	// new OnePageNavigation();

	// DoubleTouch.init();
	// $( '#main-navigation li:has(ul)' ).doubleTouch();

	$window.on("load", function() {
	});
})( jQuery, window, document );

// Uncomment to load IE11 polyfill for CSS Custom Properties
// window.MSInputMethodContext && document.documentMode && document.write('<script src="https://cdn.jsdelivr.net/gh/nuxodin/ie11CustomProperties@4.1.0/ie11CustomProperties.min.js"><\/script>');
